import { render, staticRenderFns } from "./MyWebinars.vue?vue&type=template&id=d81b8bb2&scoped=true"
import script from "./MyWebinars.vue?vue&type=script&lang=js"
export * from "./MyWebinars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81b8bb2",
  null
  
)

export default component.exports